module.exports = __webpack_public_path__ + "static/media/the_sky_is_on_fire_1k.61a16744.hdr";